import { render, staticRenderFns } from "./LongingForZekiMuren.vue?vue&type=template&id=0876fb33&scoped=true&lang=pug&"
import script from "./LongingForZekiMuren.vue?vue&type=script&lang=js&"
export * from "./LongingForZekiMuren.vue?vue&type=script&lang=js&"
import style0 from "./LongingForZekiMuren.vue?vue&type=style&index=0&id=0876fb33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0876fb33",
  null
  
)

export default component.exports